import React from "react"
import "./steps.sass"
import IconSucc from "../../images/partner/icon-succ@2x.png"
import IconPhone from "../../images/partner/icon-phone@2x.png"
import IconHand from "../../images/partner/icon-hand@2x.png"
import IconForm from "../../images/partner/icon-form@2x.png"
import Button from "../../components/button"
import { defaultIntl } from "../../utils"
import { applyTypes } from "../../components/forms/form"
import { MERCHANT } from "../../../config"

export default ({ intl = defaultIntl }) => {
  return (
    <div className="partner-steps">
      <div className="container">
        <h2>{intl.formatMessage({ id: "partner.steps.title" })}</h2>
        <p>{intl.formatMessage({ id: "partner.steps.desc" })}</p>
        <div className="columns">
          <div className="column is-one-quarter">
            <article className="media">
              <div className="media-left">
                <figure className="image is-72x72">
                  <img src={IconHand} alt="Image" />
                </figure>
              </div>
              <div className="media-content">
                <h3>{intl.formatMessage({ id: "partner.steps.a.title" })}</h3>
                <p>{intl.formatMessage({ id: "partner.steps.a.desc" })}</p>
              </div>
            </article>
          </div>
          <div className="column is-one-quarter">
            <article className="media">
              <div className="media-left">
                <figure className="image is-72x72">
                  <img src={IconForm} alt="Image" />
                </figure>
              </div>
              <div className="media-content">
                <h3>{intl.formatMessage({ id: "partner.steps.b.title" })}</h3>
                <p>{intl.formatMessage({ id: "partner.steps.b.desc" })}</p>
              </div>
            </article>
          </div>
          <div className="column is-one-quarter">
            <article className="media">
              <div className="media-left">
                <figure className="image is-72x72">
                  <img src={IconPhone} alt="Image" />
                </figure>
              </div>
              <div className="media-content">
                <h3>{intl.formatMessage({ id: "partner.steps.c.title" })}</h3>
                <p>{intl.formatMessage({ id: "partner.steps.c.desc" })}</p>
              </div>
            </article>
          </div>
          <div className="column is-one-quarter">
            <article className="media">
              <div className="media-left">
                <figure className="image is-72x72">
                  <img src={IconSucc} alt="Image" />
                </figure>
              </div>
              <div className="media-content">
                <h3>{intl.formatMessage({ id: "partner.steps.d.title" })}</h3>
                <p>{intl.formatMessage({ id: "partner.steps.d.desc" })}</p>
              </div>
            </article>
          </div>
        </div>
        <Button to={`${MERCHANT}/${intl.locale}/`}>{intl.formatMessage({ id: "partner.steps.btn" })}</Button>
      </div>
    </div>
  )
}
